<template>
  <div id="content" class="app-content">
    <b-row>
      <b-col>
        <h1 class="page-header">Suppliers Requests</h1>
      </b-col>
    </b-row>

    <b-card>
      <b-table
        :fields="fields"
        :items="mapItems(listing)"
        show-empty
        bordered
        hover
        stacked="sm"
        @row-clicked="row => showDetails(row)"
      >
        <template v-slot:cell(options)="row">
          <b-button
            v-if="!row.item.accepted"
            v-b-modal="`suppliers-requests-${row.item.id}`"
            size="sm"
            :disabled="$cannot('suppliers-requests.manage')"
          >
            Mark as reviewed
          </b-button>

          <b-modal :id="`suppliers-requests-${row.item.id}`" title="Mark as reviewed" @ok="markAsReviewed(row.item)">
            Are you sure you want to mark this request as reviewed?
          </b-modal>
        </template>

        <template v-slot:row-details="{ item }">
          <b-overlay :show="loading === item.id">
            <supplier-request-details :request="item" @loaded="loading = 0" />
          </b-overlay>
        </template>
      </b-table>

      <b-pagination
        v-model="meta.current_page"
        :total-rows="meta.total"
        :per-page="meta.per_page"
        @change="paginationChange"
      />
    </b-card>
  </div>
</template>

<script>
import SupplierRequestDetails from './SupplierRequestDetails.vue';

export default {
  name: 'SuppliersRequestsPage',

  inject: ['$cannot'],

  components: { SupplierRequestDetails },

  beforeRouteEnter(from, to, next) {
    next(vm => vm.loadContent())
  },

  data() {
    return {
      loading: 0,
      current: 0,
      listing: [],
      meta: {
        current_page: 1,
        from: 0,
        last_page: 1,
        path: '',
        per_page: 0,
        to: 0,
        total: 0,
      },
    }
  },

  computed: {
    fields() {
      return [
        { key: 'id', sortable: false, label: 'ID' },
        { key: 'supplier.invoice_legal_name', sortable: false, label: 'Supplier name' },
        { key: 'variation.product.name', sortable: false, label: 'Product name' },
        { key: 'variation.variation_name', sortable: false, label: 'Product variation' },
        { key: 'accepted', sortable: false, label: 'Reviewed', formatter: value => value ? 'Yes' : 'No' },
        { key: 'options', sortable: false, label: '' },
      ]
    },
  },

  methods: {
    async loadContent() {
      const page = this.$route.query.page ?? 1
      const response = await this.$store.dispatch('supplierRequests/listing', page)

      this.$nextTick(() => {
        this.listing = response.data()
        this.meta = response.meta
      })
    },

    paginationChange(page) {
      this.$router.push(page === 1 ? { name: 'suppliers-requests' } : { name: 'suppliers-requests', query: { page } })
      this.loadContent()
    },

    showDetails(request) {
      this.loading = request.id
      this.current = request.id === this.current ? 0 : request.id
      request._showDetails = !request._showDetails
    },

    mapItems(items) {
      return items.map(item => ({ ...item, _showDetails: this.current === item.id }))
    },

    async markAsReviewed(item) {
      await this.$store.dispatch('auth/refreshToken');
      await this.$store.dispatch('supplierRequests/update', item.id)
      const listItem = this.listing.filter(i => i.id === item.id)[0]
      listItem.accepted = true
      item.accepted = true
    }
  },
}
</script>
